import { currentUser } from '../assets/utils/user';

export class ProjectList {
  constructor () {
    this.project = [
      { name: 'Magnolias French Country', code: 'M4' },
      { name: 'The ICONSIAM Superlux Residence', code: 'MO' },
      { name: 'Magnolias Ratchadamri Boulevard', code: 'MRB' },
      { name: 'Magnolias Waterfront Residences', code: 'MWR' },
      { name: 'The Strand', code: 'TSTC' },
      { name: 'Whizdom the exclusive', code: 'W1' },
      { name: 'Whizdom @ Punnawithi station', code: 'W2' },
      { name: 'Whizdom Avenue Ratchada-Ladprao', code: 'WARL' },
      { name: 'Whizdom Asoke-Sukhumvit', code: 'WAS' },
      { name: 'Whizdom Connect', code: 'WC' },
      { name: 'Whizdom Essence Sukhumvit', code: 'WE' },
      { name: 'Whizdom Inspire Sukhumvit', code: 'WIS' },
      { name: 'Whizdom Station Ratchada-Thapra', code: 'WSRT' },
      { name: 'Mulberry Grove Sukhumvit', code: 'MBSC' },
      { name: 'Mulberry Grove The Forestias Villas', code: 'MBFV' },
      { name: 'Whizdom The Forestias(Destinia and Mytopia)', code: 'WFDM' },
      { name: 'Whizdom The Forestias(Petopia)', code: 'WFP' },
      { name: 'The Aspen Tree Residence at The FORESTIAS', code: 'ASPF' },
      { name: 'Mulberry Grove The Forestias Condomimium', code: 'MBFC' }
    ];
  }

  getProjectSelectDrobdownObject () {
    // extract user project
    const permission = currentUser().permission;
    if (-1 !== permission.indexOf('project-*')) { // allow all projects
      return this.project.map(p => { return { label: p.name, code: p.code }; });
    } else {
      let userProjects = permission.filter(p => {
        return p.split('project-').length > 1;
      }).map(u => u.substring(8, u.length).toUpperCase());
      return this.project.filter(p => -1 !== userProjects.indexOf(p.code)).map(p => { return { label: p.name, code: p.code }; });
    }
  }

  getProjectSelectDrobdownObjectWithAll () {
    const permission = currentUser().permission;
    if (-1 !== permission.indexOf('project-*')) { // allow all projects
      return [{ label: 'All', code: this.project.map(p => p.code) }, ...this.project.map(p => { return { label: p.name, code: p.code }; })];
    } else {
      let userProjects = permission.filter(p => {
        return p.split('project-').length > 1;
      }).map(u => u.substring(8, u.length).toUpperCase());
      return this.project.filter(p => -1 !== userProjects.indexOf(p.code)).map(p => { return { label: p.name, code: p.code }; });
    }
  }

  getProjectFilter () {
    // extract user project
    const permission = currentUser().permission;
    if (-1 !== permission.indexOf('project-*')) { // allow all projects
      const projectList = this.project.map(p => { return { label: p.name, code: p.code }; });
      const all = [{ label: 'All', code: 'ALL' }];
      return [ ...all, ...projectList ];
    } else {
      let userProjects = permission.filter(p => {
        return p.split('project-').length > 1;
      }).map(u => u.substring(8, u.length).toUpperCase());
      return this.project.filter(p => -1 !== userProjects.indexOf(p.code)).map(p => { return { label: p.name, code: p.code }; });
    }
  }

  /**
   * @param {String} code
   */
  getProjectNameByCode (code) {
    const project = this.project.find(p => p.code === code);
    return project ? project.name : '';
  }
}
